export default __webpack_public_path__ + "static/hasuracon-recording-bg-8e3057b714324a4b8d291c7dd50b11d8.png";